<p>detail-list works!</p>
